import React from "react";
import { ErrorBoundary } from "@gw/web-basic-components";
import { GWErrorBoundaryProps } from "./dto";
import { useWebSentry } from "@gw/gw-sentry";

let sentryRef: any = null;

export const initErrorLogger = (sentry: any) => {
  sentryRef = sentry;
};

// 上报错误记录
export const createErrorLogger = async (error: any) => {
  try {
    // @ts-ignore  后期改组件将舍弃 暂时先ts-ignore
    if (window.configCenter?.disableErrorReport) {
      return;
    }
    // 调用 sentry 上报
    if (sentryRef?.captureException) {
      sentryRef.captureException(error);
    }
  } catch (err) {
    console.log("错误日志上报失败", err);
  }
};

// 错误日志上报组件
const GWErrorBoundary: React.FC<GWErrorBoundaryProps> = (props) => {
  try {
    const sentry = useWebSentry();
    initErrorLogger(sentry); // 初始化 sentry
  } catch (error) {
    console.warn("Invalid sentry instance provided to initErrorLogger");
  }

  return (
    <ErrorBoundary
      refreshKey={props.refreshKey}
      fallback={props.fallback}
      onError={createErrorLogger}
    >
      {props.children}
    </ErrorBoundary>
  );
};

export default GWErrorBoundary;
